import { axiosWithAuth } from "../../helpers";

export const feesService = {
	loadFeesTemplates,
	loadAppClonedFeesTemplates,
	batchCloneFeesTemplates,
};

const API_URL = process.env.REACT_APP_API_URL;

function loadFeesTemplates({ primaryAgentId }) {
	const options = {
		url: `${API_URL}/api/applications/templates/${primaryAgentId}`,
	};

	return axiosWithAuth(options);
}

function loadAppClonedFeesTemplates({ applicationId }) {
	const options = {
		url: `${API_URL}/api/applications/${applicationId}/cloned-fees-templates`,
	};

	return axiosWithAuth(options);
}

function batchCloneFeesTemplates({
	applicationId,
	additionalFeesTemplateId,
	monthlyFeesTemplateId,
}) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/batch-clone-fees-templates`,
		data: {
			applicationId,
			additionalFeesTemplateId,
			monthlyFeesTemplateId,
		},
	};

	return axiosWithAuth(options);
}
